module.exports = __webpack_public_path__ + "static/media/creditCard.7f0344dc.svg";